/// <amd-module name="Artifacts/Nuget/commands/GetLink" />
import { getLinkCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createGetLinkCommand = getLinkCommandCreator();
